import { useState } from "react";
import { LuEye, LuEyeOff } from "react-icons/lu";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface IPasswordFieldProps extends React.ComponentProps<"input"> {
    isPending: boolean;
}


export const PasswordField = ({ isPending, ...props }: IPasswordFieldProps) => {
    const [ showPassword, setShowPassword ] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="relative">
            <Input { ...props } className="pr-10" disabled={ isPending } type={ showPassword ? "text" : "password" } />
            <Button
                type="button"
                variant="ghost"
                className="absolute inset-y-0 right-0 flex items-center"
                size={ "sm" }
                onClick={ togglePasswordVisibility }
            >
                {showPassword ? <LuEyeOff /> : <LuEye />}
            </Button>
        </div>
    );
};